document.addEventListener 'DOMContentLoaded', ->
  menuIcon = document.getElementById('menu-icon')
  toggleMenu = (e) ->
    if menuIcon.classList.contains 'open'
      document.getElementById('responsive-navigation').classList.remove 'active'
      menuIcon.classList.remove 'open'
    else
      document.getElementById('responsive-navigation').classList.add 'active'
      menuIcon.classList.add 'open'
    e.preventDefault()

  menuIcon.addEventListener 'click', toggleMenu
  menuIcon.addEventListener 'touchstart', toggleMenu
